import React, { useEffect } from 'react';
import styled from 'styled-components';
import ContentLoader from 'react-content-loader';
import { useHistory } from 'react-router-dom';

import Hero from './HeroSection/Hero';
import useThemes from '../hooks/useThemes';
import Card from './Cards/Card';
import { useApi } from '../hooks/useApi';

export const PageServices = () => {
  window.scroll(0, 0);
  const { backgroundSexto, backgroundSeptimo, colorPrincipal } = useThemes();
  const { servicios, getBanners, getServicios } = useApi();
  const { push } = useHistory();

  const handleClick = (item) => {
    push({ pathname: '/servicio-detalle', state: item });

    // if (item.nombreOpcion === 'Doctor famedic') {
    //   window.open(banners.data.doctorFamedic, '_blank');
    // } else {
    //   push(item.rutaOpcion);
    // }
  };

  useEffect(() => {
    getBanners();
    getServicios();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container background={backgroundSexto}>
      <Hero
        title='Servicios'
        subtitle='ACOMPAÑAMIENTO COMPLETO EN TUS PROCEDIMIENTOS'
        imgSrc='img/Servicios/seccion-servicios.png'
        color={backgroundSexto}
      />

      {servicios.isLoading ? (
        <div className='grid-container'>
          {[...Array(6).keys()].map((_, index) => (
            <div className='grid-item' key={index}>
              <ContentLoader
                speed={2}
                width='100%'
                height='auto'
                foregroundColor={colorPrincipal}
                backgroundColor={backgroundSeptimo}
              >
                <rect x='0' y='0' rx='30' ry='30' width='100%' height='500' />
              </ContentLoader>
            </div>
          ))}
        </div>
      ) : (
        <div className='grid-container'>
          {servicios.data.map(
            (item) =>
              item?.activo && (
                <Card
                  img={item.imagen}
                  titulo={item.nombreOpcion}
                  texto={item.texto}
                  key={item.id}
                  onClick={() => handleClick(item)}
                />
              )
          )}
        </div>
      )}
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  background-color: ${(props) => props.background};
  padding-bottom: 5rem;

  .grid-container {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(36rem, 1fr));
    margin-top: 5vh;
    padding: 1rem 10rem;

    .grid-item {
      min-height: 50rem;
      min-width: 36rem;
    }
  }

  @media (max-width: 1023px) {
    .grid-container {
      grid-template-columns: repeat(auto-fit, minmax(26rem, 1fr));
      padding: 2rem;

      .grid-item {
        min-width: 16rem;
      }
    }
  }
`;
